// extracted by mini-css-extract-plugin
module.exports = {"attribute-menu-trigger":"attributes_attribute-menu-trigger__Hsb80","page-container":"attributes_page-container__IGtAk"};